import TotalCustomer from './TotalCustomer';

export default (props) => {
  return <TotalCustomer {...props} />;
};
